import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,293.333 L960,453.333 L186.667,453.333 C171.939,453.333 160,465.272 160,480 L160,1733.33 C160,1748.06 171.939,1760 186.667,1760 L1440,1760 C1454.73,1760 1466.67,1748.06 1466.67,1733.33 L1466.67,960 L1626.67,960 L1626.67,1733.33 C1626.67,1836.43 1543.09,1920 1440,1920 L186.667,1920 C83.5735,1920 0,1836.43 0,1733.33 L0,480 C0,376.907 83.5735,293.333 186.667,293.333 L960,293.333 Z M586.667,800 L1120,1120 L586.667,1440 L586.667,800 Z M1626.67,0 L1626.67,293.333 L1920,293.333 L1920,453.333 L1626.67,453.333 L1626.67,746.667 L1466.67,746.667 L1466.67,453.333 L1173.33,453.333 L1173.33,293.333 L1466.67,293.333 L1466.67,0 L1626.67,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAddMediaSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAddMediaSolid, _Component);

  var _super = _createSuper(IconAddMediaSolid);

  function IconAddMediaSolid() {
    _classCallCheck(this, IconAddMediaSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAddMediaSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAddMedia",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAddMediaSolid.displayName = "IconAddMediaSolid";
  return IconAddMediaSolid;
}(Component);

IconAddMediaSolid.glyphName = 'add-media';
IconAddMediaSolid.variant = 'Solid';
IconAddMediaSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAddMediaSolid;
export { IconAddMediaSolid };